// https://developer.devrev.ai/sdks/web/installation
export const DEVREV_PLUG_SDK_URL = 'https://plug-platform.devrev.ai/static/plug.js';
